module.exports = __webpack_public_path__ + "img/Bangladesh.c1533f37.png";